(function() {

    'use strict';
    angular.module('app')
        .controller('featureRequestController',
            [
                '$scope',
                '$sce',
                '$location',
                '$uibModal',
                '$cookies',
                'accountsService',
                featureRequestController
            ]
    );

    function featureRequestController($scope, $sce, $location, $uibModal, $cookies, accountsService) {
        
        var vm = this;
        vm.hello = 'Hello World';
        vm.account = null;
        vm.loader = true;
        vm.acceptedTC = false;
        vm.alert = false;
        vm.hasGrantedThirdParty = false;

        accountsService.getAuthenticatedAccount().then(function (data) {
            vm.account = data;
            vm.beginCanny(vm.account.accountId);
        });

        vm.beginCanny = function (accountId) {
            accountsService.getAccount(accountId).then(function(data) {
                vm.accountDetails = data;
                if (!vm.accountDetails.showFeatureRequest)
                    $location.url('/dashboard');

                if (vm.accountDetails.cannyId === null || vm.accountDetails.cannyId === '')
                    $('#tAndC').modal({ 'show': true, "backdrop": 'static', "keyboard": false });
                else
                    vm.loadCanny(accountId);
            });
        };

        vm.nope = function () {
            $('#tAndC').modal('hide');
            $location.url('/dashboard');
        }

        vm.accepted = function () {
            if ($('#acceptedTC')[0].checked) {
                vm.hasGrantedThirdParty = true;
                $('#tAndC').modal('hide');
                vm.runCannySetup(vm.account.accountId);
            } else {
                vm.alert = true;
            }
        }

        vm.runCannySetup = function(accountId) { 
            if (vm.hasGrantedThirdParty) {
                accountsService.createCannyUser(accountId).then(function(data) {
                    vm.accountDetails.cannyId = data.id;
                    vm.loadCanny(accountId);
                });
            }
        };
        
        vm.loadCanny = function (accountId) {
            accountsService.getCannySsoToken(accountId).then(function(data) {
                Canny('render', {
                    boardToken: 'ebcc4af0-e24c-51ea-871a-c60e48b2c3c9',
                    basePath: '/FeatureRequest',
                    ssoToken: data, 
                });
                vm.loader = false;
            });
        };
    }
})();